import { ScreenName } from '@helpcenter/constants';
import type { RouteResource } from 'react-resource-router';
import { brandingResource } from 'routes/advanced-help-center/resources/multi-help-centers';
import { Login } from 'view/login';
import FeatureGates from '@atlaskit/feature-gate-js-client';
import { createRouteWithLayout } from '@atlassian/help-center-common-util/resource-router';
import { anonymousScreenLayout, PORTAL_ROUTE_PREFIX, LOGIN_ROUTE } from '../common/constants';
import { loginAnnouncementsCardResource, delayResource } from './resources';

const resources: RouteResource[] = FeatureGates.checkGate('jsm_multi_helpcenter_login_ssr_improvements')
    ? [brandingResource, loginAnnouncementsCardResource, ...(__SERVER__ ? [delayResource] : [])]
    : [];

const portalLogin = {
    resources,
    name: 'portal-login',
    path: `${PORTAL_ROUTE_PREFIX}/user/login`,
    exact: true,
    component: Login,
};

const login = {
    resources,
    name: 'login',
    path: LOGIN_ROUTE,
    exact: true,
    component: Login,
};

const screenName = ScreenName.LOGIN;

const layoutProps = FeatureGates.checkGate('jsm_multi_helpcenter_login_ssr_improvements')
    ? { ...anonymousScreenLayout, prefetchBrandingModel: true }
    : anonymousScreenLayout;

export const loginRoute = createRouteWithLayout(login, screenName, layoutProps);
export const portalLoginRoute = createRouteWithLayout(portalLogin, screenName, layoutProps);
